/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-21 23:50:51
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 18:21:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/Components/hooks/customHooks.tsx
 */
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { useHistory } from 'react-router';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { eForceUpdate } from 'src/constrains/SalesChannelMultiLanguageSelect';

//import { instanceType, AllTypes } from 'src/tools/helper';
const switchUuidHooks = ({ getUuid, _key, url }) => {
  const _h = useHistory();

  const _d: any = useSelector(getUuid());
  const { uuid, salesChannelUuid } = _d;

  const _params = useParams();

  useAfterDidMountEffect(() => {
    if (uuid !== _params[_key]) {
      _h.push(`${url}/${salesChannelUuid}/${uuid}`);
      // console.log('uuid switch');
      eForceUpdate(uuid);
    }
  }, [uuid]);
};
export { switchUuidHooks };
